"use client";

import { c as _c } from "react/compiler-runtime";
import { Code, Menu, X } from "lucide-react";
import Link from "next/link";
import { useState } from "react";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { Button } from "@/components/ui/button";
import { useUser } from "@/hooks/useUser";
import { useAppConfig } from "@/lib/config";
import { useI18n } from "@llmgateway/i18n/react";
export function Header() {
  const $ = _c(61);
  const config = useAppConfig();
  const {
    t
  } = useI18n();
  const {
    user,
    isLoading
  } = useUser();
  const isAuthenticated = !!user && !isLoading;
  const [menuOpen, setMenuOpen] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-foreground text-background"><Code className="h-4 w-4" /></div>;
    t1 = <span className="font-semibold text-lg">DevPass</span>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("brand.byGateway");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <Link href="/" className="flex items-center gap-2">{t0}{t1}<span className="hidden sm:inline text-xs text-muted-foreground">{t2}</span></Link>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("nav.models");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <Button variant="ghost" size="sm" asChild={true}><Link href="/coding-models">{t4}</Link></Button>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("nav.guides");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <Button variant="ghost" size="sm" asChild={true}><Link href="/guides">{t6}</Link></Button>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("nav.pricing");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <Button variant="ghost" size="sm" asChild={true}><Link href="/pricing">{t8}</Link></Button>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t) {
    t10 = t("nav.compare");
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10) {
    t11 = <Button variant="ghost" size="sm" asChild={true}><Link href="/compare">{t10}</Link></Button>;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const t12 = config.docsUrl;
  let t13;
  if ($[22] !== t) {
    t13 = t("nav.docs");
    $[22] = t;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== config.docsUrl || $[25] !== t13) {
    t14 = <Button variant="ghost" size="sm" asChild={true}><a href={t12} target="_blank" rel="noopener noreferrer">{t13}</a></Button>;
    $[24] = config.docsUrl;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <LanguageSwitcher />;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== isAuthenticated || $[29] !== t) {
    t16 = isAuthenticated ? <Button size="sm" asChild={true}><Link href="/dashboard">{t("nav.dashboard")}</Link></Button> : <><Button variant="ghost" size="sm" asChild={true}><Link href="/login">{t("nav.signIn")}</Link></Button><Button size="sm" asChild={true}><Link href="/signup">{t("nav.getStarted")}</Link></Button></>;
    $[28] = isAuthenticated;
    $[29] = t;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t11 || $[32] !== t14 || $[33] !== t16 || $[34] !== t5 || $[35] !== t7 || $[36] !== t9) {
    t17 = <div className="hidden sm:flex items-center gap-3">{t5}{t7}{t9}{t11}{t14}{t15}{t16}</div>;
    $[31] = t11;
    $[32] = t14;
    $[33] = t16;
    $[34] = t5;
    $[35] = t7;
    $[36] = t9;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== menuOpen) {
    t18 = () => setMenuOpen(!menuOpen);
    $[38] = menuOpen;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== menuOpen || $[41] !== t) {
    t19 = menuOpen ? t("nav.closeMenu") : t("nav.openMenu");
    $[40] = menuOpen;
    $[41] = t;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== menuOpen) {
    t20 = menuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />;
    $[43] = menuOpen;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t18 || $[46] !== t19 || $[47] !== t20) {
    t21 = <button type="button" onClick={t18} className="sm:hidden p-2 -mr-2" aria-label={t19}>{t20}</button>;
    $[45] = t18;
    $[46] = t19;
    $[47] = t20;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== t17 || $[50] !== t21 || $[51] !== t3) {
    t22 = <div className="container mx-auto px-4 py-4 flex items-center justify-between">{t3}{t17}{t21}</div>;
    $[49] = t17;
    $[50] = t21;
    $[51] = t3;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== config.docsUrl || $[54] !== isAuthenticated || $[55] !== menuOpen || $[56] !== t) {
    t23 = menuOpen && <div className="sm:hidden border-t border-border/50 px-4 py-4 space-y-3"><Link href="/coding-models" className="block text-sm text-muted-foreground hover:text-foreground transition-colors" onClick={() => setMenuOpen(false)}>{t("nav.models")}</Link><Link href="/guides" className="block text-sm text-muted-foreground hover:text-foreground transition-colors" onClick={() => setMenuOpen(false)}>{t("nav.guides")}</Link><Link href="/pricing" className="block text-sm text-muted-foreground hover:text-foreground transition-colors" onClick={() => setMenuOpen(false)}>{t("nav.pricing")}</Link><Link href="/compare" className="block text-sm text-muted-foreground hover:text-foreground transition-colors" onClick={() => setMenuOpen(false)}>{t("nav.compare")}</Link><a href={config.docsUrl} target="_blank" rel="noopener noreferrer" className="block text-sm text-muted-foreground hover:text-foreground transition-colors">{t("nav.docs")}</a><LanguageSwitcher className="w-full" />{isAuthenticated ? <Button size="sm" className="w-full" asChild={true}><Link href="/dashboard" onClick={() => setMenuOpen(false)}>{t("nav.dashboard")}</Link></Button> : <><Link href="/login" className="block text-sm text-muted-foreground hover:text-foreground transition-colors" onClick={() => setMenuOpen(false)}>{t("nav.signIn")}</Link><Button size="sm" className="w-full" asChild={true}><Link href="/signup" onClick={() => setMenuOpen(false)}>{t("nav.getStarted")}</Link></Button></>}</div>;
    $[53] = config.docsUrl;
    $[54] = isAuthenticated;
    $[55] = menuOpen;
    $[56] = t;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  let t24;
  if ($[58] !== t22 || $[59] !== t23) {
    t24 = <header className="border-b border-border/50">{t22}{t23}</header>;
    $[58] = t22;
    $[59] = t23;
    $[60] = t24;
  } else {
    t24 = $[60];
  }
  return t24;
}